import styled from 'styled-components';

export const ConfigureContainerStyle = styled('div')`
    font-family: 'Poppins' !important;
    margin: 0px auto;
    padding-top: 30px;
`;